import src from "IMAGE";
export default { src, width: 264, height: 276, blurWidth: 0, blurHeight: 0};
